import { render, staticRenderFns } from "./Labor.vue?vue&type=template&id=7b1ba868&scoped=true"
import script from "./Labor.vue?vue&type=script&lang=js"
export * from "./Labor.vue?vue&type=script&lang=js"
import style0 from "./Labor.vue?vue&type=style&index=0&id=7b1ba868&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1ba868",
  null
  
)

export default component.exports